import { render, staticRenderFns } from "./EmailDeliveryDetailDialog.vue?vue&type=template&id=a741b2d4"
import script from "./EmailDeliveryDetailDialog.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailDeliveryDetailDialog.vue?vue&type=style&index=0&id=a741b2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports